/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListCheck = [
  ["path", { d: "M16 5H3" }],
  ["path", { d: "M16 12H3" }],
  ["path", { d: "M11 19H3" }],
  ["path", { d: "m15 18 2 2 4-4" }]
];

export { ListCheck as default };
//# sourceMappingURL=list-check.js.map
